/* import __COLOCATED_TEMPLATE__ from './notes.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();